import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=5b7cd9ef&lang=less"

const __exports__ = script;

export default __exports__